import type {
	SitePermissionType,
	GlobalOperationsUserPermissionTypeQuery$data,
} from './__generated__/GlobalOperationsUserPermissionTypeQuery.graphql.ts';

export const getUserPermissionFromQuery = (
	queryData: GlobalOperationsUserPermissionTypeQuery$data | null | undefined,
): SitePermissionType | null | undefined => {
	return queryData?.user?.confluence?.permissionType;
};
